import { render, staticRenderFns } from "./organizations.vue?vue&type=template&id=3f2d03b7&scoped=true&"
import script from "./organizations.vue?vue&type=script&lang=js&"
export * from "./organizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d03b7",
  null
  
)

export default component.exports